import BaseModel from '@/store/models/BaseModel';

export default class Rating extends BaseModel {}
